module.exports = __webpack_public_path__ + "img/userLogo7.88a723b3.jpg";